
    import { Component, Vue } from "vue-property-decorator";
    import { Dialog, Toast } from "vant";
    import UAgreement from "../../agreement.vue";
    import UPrivacy from "../../privacy.vue";
    import UAuthorization from "../../authorization.vue";
    import globalConfig from "src/config/index";
    import ermInfo from "../../ermInfo.vue";
    import { UserService } from "src/services";
    
    @Component({
        components:
        {
            UPrivacy,
            UAgreement,
            UAuthorization,
            ermInfo
        }
    })
    export default class Privacy extends Vue
    {

        /**
         * 是否显示服务协议
         * @private
         * @returns boolean
         */
        private showAgreement: boolean = false;

        /**
         * 是否显示隐私协议
         * @private
         * @returns boolean
         */
        private showPrivacy: boolean = false;

        /**
         * 是否显示服务隐私协议
         * @private
         * @returns number
         */
        private showErmInfoModal: boolean = false;

        /* 业务员隐私协议关闭
          * @private
          * @returns void
          */
        private async onCloseErmInfoModal(): Promise<void>
        {
            this.showErmInfoModal = false;
        }

        /**
         * 服务隐私协议id
         * @private
         * @returns number
         */
        private ermInfoId: any = null;

        /* 业务员隐私协议显示
        * @private
        * @returns void
        */
        private async onTermInfos(id): Promise<void>
        {
            this.ermInfoId = id;
            this.showErmInfoModal = true;
        }

        /**
         * 获取当前登入机构信息
         * @private
         * @returns void
         */
        private orgInfo:any = {}


        private created(): void {
            let code = localStorage.getItem("appid");
            // 获取机构信息
            this.getOrgInfo(code);
        
        }

        /**
         * 获取机构详情
         * @private
         * @returns void
         */
        private async getOrgInfo(code: string): Promise<void>
        {
            try
            {
                let {content: result} =  await UserService.instance.getOrgInfo(code);
                this.orgInfo = result.data
            }
            catch(err)
            {
                Toast(err);
            }
        }

        /**
         * 是否显示用户授权协议
         * @private
         * @returns boolean
         */
        private showAuthorization: boolean = false;

        /**
         * 获取当前登入企业相关配置
         * @private
         * @returns void
         */
        protected get employerConfig(): any
        {
            let appid = localStorage.getItem("appid");

            let employerConfig = globalConfig.employerConfig[appid];

            return employerConfig;
        }

        /**
         * 打开隐私协议
         * @private
         * @returns void
         */
        private onPrivacy(): void
        {
            this.showPrivacy = true;
        }

        /**
         * 打开服务协议
         * @private
         * @returns void
         */
        private onAgreement(): void
        {
            this.showAgreement = true;
        }


        /**
         * 用户授权协议
         * @private
         * @returns void
         */
        private onAuthorization(): void {
            this.showAuthorization = true;
        }


        /* 关闭用户协议
        * @private
        * @returns void
        */
        private closeAgreement(): void
        {
            this.showAgreement = false;
        }

        /* 关闭用户授权协议
        * @private
        * @returns void
        */
        private closeAuthorization() {
            this.showAuthorization = false
        }

        /* 关闭隐私协议
        * @private
        * @returns void
        */
        private closePrivacy(): void
        {
            this.showPrivacy = false;
        }
        
    }
    